import _styled, { default as _styled2 } from "styled-components";
var _templateObject;
var _excluded = ["label"];
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { Radio } from '@noths/polaris-client-ribbons-design-system';
import * as styles from "./RadioWithLabel.styles";
export var RadioWithLabel = function RadioWithLabel(_ref) {
  var label = _ref.label,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(_StyledLabel, {
    $_css: [styles.radioButtonWrapper, props.disabled && styles.radioButtonWrapperDisabled]
  }, /*#__PURE__*/React.createElement(Radio, _extends({}, props, {
    "aria-label": label
  })), /*#__PURE__*/React.createElement(_StyledSpan, {
    $_css2: styles.radioButtonLabelText
  }, label));
};
var _StyledLabel = _styled("label")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledSpan = /*#__PURE__*/_styled2("span").withConfig({
  displayName: "RadioWithLabel___StyledSpan",
  componentId: "sc-1h5208m-0"
})(["", ""], function (p) {
  return p.$_css2;
});